import { Component, OnInit } from '@angular/core';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { I18nService } from 'src/app/shared/service/i18n.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { EnvironmentconfigService } from '../../shared/service/environmentconfig.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { TranslateService } from '@ngx-translate/core';
import {
  HttpClient,
  HttpHeaders,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { DeliveryScheduleMaintenanceService } from 'src/app/WMSM-Pages/WMSM001/WMSM001.component.service';


@Component({
  selector: 'app-WMSM001',
  templateUrl: './WMSM001.component.html',
  styleUrls: ['./WMSM001.component.scss'],
})
export class WMSM001Component extends BaseComponent implements OnInit {




  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;

  listOfData: any[] = [];
  nzTotal: number = 0;
  validateForm: FormGroup;
  editData: any;
  isEdit: boolean = false;
  fileList: NzUploadFile[] = [];
  formValues: any;
  Userlimits: boolean = false;
  Buyerlimits: boolean = false;
  VendorAll: any;
  fixedColumn = true;
  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  isShowCondition: boolean = true;
  isShowQuery: boolean = true;
  loading: boolean = false;
  cn: boolean;
  tw: boolean;
  en: boolean;
  vn: boolean;
  EnvironmentconfigService: any;
  //currentPage:string;
  constructor(
    private webApiService: WebApiService,
    private messageService: NzMessageService,
    private i18m: I18nService,
    private AuthService: AuthService,
    private fb: FormBuilder,
    private Environment: EnvironmentconfigService,
    private translate: TranslateService,
    private http: HttpClient,
    private matomotracker: MatomoTracker,
    private LayoutComponent: LayoutComponent,
    private deliveryScheduleMaintenanceService: DeliveryScheduleMaintenanceService
  ) {
    super();
  }

  ngOnInit() {

    this.matomotracker.trackPageView("交期互動")
    this.matomotracker.trackEvent("交期互動", "交期維護", "Transation", 1);

    this.LayoutComponent.geturl()
  }




  getLanguage() {
    var language = sessionStorage.getItem("wmsmlang");
    if (language == 'zh-CN') {
      this.cn = true;
      this.tw = false;
      this.en = false
      this.vn = false
    }
    if (language == 'zh-TW') {
      this.tw = true;
      this.cn = false
      this.en = false
      this.vn = false
    }
    if (language == 'en') {
      this.en = true;
      this.cn = false;
      this.tw = false
      this.vn = false
    }
    if (language == 'VN') {
      this.en = false;
      this.cn = false;
      this.tw = false
      this.vn = true
    }
  }

  onEdit(data) {
    this.editData = { ...data };
    this.isEdit = true;
  }
  // 取消编辑
  closeEdit() {
    this.isEdit = false;
  }
  // 保存编辑
  saveEdit(event) {
    this.editData = null;
    this.modifyData(
      `${this.Environment.authConfig.wmsmUrl}${URLConst.Update.url}`,
      event
    );
    this.isEdit = false;
  }
  // 新增/修改表格数据
  modifyData(url, data) {
    this.loading = true;
    const formData = new FormData();
    formData.append('DeliveryNoteFile', data.VDispatchFile);
    formData.append('DelvieryOrderDocument', data.VDeliverGoodsFile);
    formData.append('CompanyCode', data.companyCode);
    formData.append('Pono', data.pono);
    formData.append('Poln', data.poln);
    formData.append('Type', ''); //後端會重取
    formData.append('VDate', data.vDate || '');
    formData.append('UDate', data.uDate || '');
    formData.append('VendorRemark', data.vendorRemark);
    formData.append('UnreasonCode', data.unreasonCode);
    formData.append('Unreason', data.unreason);
    formData.append('VDeliveryDate', data.VDeliveryDate || '');
    formData.append('VAcDate', data.VAcDate || '');
    formData.append('vDeliverGoodsFiletoken', data.vDeliverGoodsFiletoken || '');
    formData.append('vDispatchFiletoken', data.vDispatchFiletoken || '');
    formData.append('ShippingFileName', data.ShippingFileName || '');
    formData.append('vDeliverGoodsFileName', data.vDeliverGoodsFileName || '');
    console.log(data.VDeliverGoodsFile, "")
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse))
      .subscribe(
        (res) => {
          if (res['body'].status == 200) {
            this.messageService.success(res['body'].msg);
            // 延遲查詢以確保後端資料已更新
            setTimeout(() => {
              this.getResultData();
            }, 500);
          } else {
            this.messageService.error(res['body'].msg);
            this.loading = false;
          }
        },
        (error) => {
          this.loading = false;
        }
      );
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    this.saveExcelData(file);
    return false;
  };
  // 保存表格中的数据
  saveExcelData(file) {
    this.loading = true;
    // 上传格式:Excel
    if (!this.ExcelControl.includes(file.type)) {
      this.messageService.warning(
        this.translate.instant('Prompt.MustUploadExcelFile')
      );
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('Type', ''); //後端會重取
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.wmsm001ExcelAddData.url}`;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse))
      .subscribe(
        (res) => {
          if (res['body'].status == this.Environment.authConfig.wmsmStatus) {
            this.getResultData();
            this.messageService.success(res['body'].msg);
          } else {
            this.messageService.warning(res['body'].msg);
          }
          this.loading = false;
        },
        (error) => {
          this.messageService.error('upload failed.');
          this.loading = false;
        }
      );
  }



  getFormValue(value) {
    this.formValues = value;
  }



  onSearch() {
    this.getLanguage();
    this.pageIndex = 1;
    this.getResultData();
  }
  // 获取查询表格数据
  getResultData() {
    let language = sessionStorage.getItem("wmsmlang");
    if (!language) {
      language = "zh-TW";
      sessionStorage.setItem("wmsmlang", language);
    }
    this.getLanguage();
    const startDate = this.formValues.POApprovedate.length !== 0 ? this.formValues.POApprovedate[0] : '';
    let endDate = '';
    if (this.formValues.POApprovedate.length !== 0) {
      const endDateObj = new Date(this.formValues.POApprovedate[1]);
      endDateObj.setDate(endDateObj.getDate() + 1);
      endDate = endDateObj.toISOString().split('T')[0];
    }
    this.loading = true;
    const data = {
      //Pono: this.validateForm.controls['PONO'].value || '',
      Pono: this.formValues.PONO,
      Prno: this.formValues.PRNO,
      vendorCode: this.formValues.Vendor,
      Buyer: this.formValues.Buyer,
      Site: this.formValues.Site,
      Language: language,
      Category: this.formValues.Type,
      FPoDate: this.getTheDateString_(startDate) || '',
      TPoDate: this.getTheDateString_(endDate) || '',
      type: '', //後端會重取
    }
    this.deliveryScheduleMaintenanceService.getResultData(this.pageSize, this.pageIndex, data).subscribe((res) => {
      this.listOfData = res.Result.data;
      this.nzTotal = res.Result.total;
      if (res.Result.status == '200') {
        this.messageService.success(res.Result.msg);
      }
      else {
        this.messageService.error(res.Result.msg);
      }
      this.loading = false;

    });


  }
  // 下载
  exportTableToExecl() {
    let language = sessionStorage.getItem("wmsmlang");
    if (!language) {
      language = "zh-TW";
      sessionStorage.setItem("wmsmlang", language);
    }
    const startDate = this.formValues.POApprovedate.length !== 0 ? this.formValues.POApprovedate[0] : '';
    let endDate = '';
    if (this.formValues.POApprovedate.length !== 0) {
      const endDateObj = new Date(this.formValues.POApprovedate[1]);
      endDateObj.setDate(endDateObj.getDate() + 1);
      endDate = endDateObj.toISOString().split('T')[0];
    }
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.wmsm001DownLoadDeliveryDateMatainExcel.url}`;
    const params = {
      data: {
        Prno: this.formValues.PRNO,
        Pono: this.formValues.PONO,
        vendorCode: this.formValues.Vendor,
        Buyer: this.formValues.Buyer,
        Site: this.formValues.Site,
        Category: this.formValues.Type,
        Language: language,
        FPoDate: this.getTheDateString_(startDate) || '',
        TPoDate: this.getTheDateString_(endDate) || '',
        type: '', //後端會重取
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      },
    };
    this.webApiService.doPost(url, params, true).subscribe((res) => {
      debugger
      if (res?.status == 0o0) {
        this.messageService.error(res.msg);
        this.loading = false;
        return;
      } else {
        this.downloadFile8(res, `Delivery_Conf_Maintain_${this.getTimeString()}.xlsx`);
        this.loading = false;
      }
    });
  }

  // 切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }
  // 切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }


  downloadFile(data, name) {
    this.webApiService.downloadFileByToken(data).subscribe(
      (res) => {
        this.downloadFile8(res, name);
        this.translate.get('DownloadSuccessfully').subscribe((translatedText: string) => {
          this.messageService.success(translatedText);
        })
        // this.messageService.success("下载成功");

      },
      (error) => {
        this.messageService.error(error.msg);
      }
    );
  }

  //查詢時觸發
  onQueryClick(): string {
    return 'deliveryScheduleMaintenanceService';
  }


  sortChange(e) {
    this.listOfData = e === 'ascend' ? this.listOfData.sort(
      (a, b) => a.pono.localeCompare(b.pono)
    ) : this.listOfData.sort(
      (a, b) => b.pono.localeCompare(a.pono)
    )
  }

}
